import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export type InitialsAvatarTone = 'accent' | 'plain' | 'outline' | 'dark';
export type InitialsAvatarSize = 'sm' | 'md' | 'lg';

const avatarVariants = cva(
  'inline-flex shrink-0 items-center justify-center rounded-full font-bold',
  {
    variants: {
      tone: {
        accent: 'bg-accent-600 text-basic-white',
        plain: 'bg-neutral-200 text-neutral-700',
        outline: 'border border-neutral-200 bg-basic-white text-neutral-700',
        dark: 'bg-ink text-basic-white',
      },
      size: {
        sm: 'size-7 text-[11px]',
        md: 'size-[34px] text-[13px]',
        lg: 'size-11 text-[15px]',
      },
    },
    defaultVariants: {
      tone: 'plain',
      size: 'md',
    },
  },
);

interface InitialsAvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Pomijane, gdy koło niesie ikonę w `children` — np. grupa bez osoby. */
  initials?: string;
  tone: InitialsAvatarTone;
  size?: InitialsAvatarSize;
}

/**
 * Koło z inicjałami (albo ikoną) — osoba, firma albo monogram rekordu. `aria-hidden`, bo
 * inicjały nie niosą nic ponad nazwę stojącą obok.
 */
const InitialsAvatar = ({
  initials,
  tone,
  size = 'md',
  className,
  children,
  ...props
}: InitialsAvatarProps) => (
  <span
    aria-hidden
    className={cn(avatarVariants({ tone, size }), className)}
    {...props}
  >
    {children ?? initials}
  </span>
);

export default InitialsAvatar;
